import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useChangePassword } from '@/hooks/account/useChangePassword';
import { ChangePasswordForm } from '@/components/features/account/changePassword';
import { LoginLayout } from '@/components/layout';


const ChangePassword: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hash = searchParams.get('hash');
  const { register, handleSubmit, errors, isSubmitting } = useChangePassword(hash);

  const handleBackToLogin = () => {
    void navigate('/login');
  };

  return (
    <LoginLayout 
      title="Ingresa nueva contraseña"
      description="Esta debe contener más de 8 dígitos con letras mayúsculas, minúsculas y números."
    >
      <ChangePasswordForm
        register={register}
        handleSubmit={handleSubmit}
        errors={errors}
        isSubmitting={isSubmitting}
        onBackToLogin={handleBackToLogin}
      />
    </LoginLayout>
  );
};

export default ChangePassword;
